import React from "react";
import { useParams } from "react-router-dom";
import { MobileTaskListView } from "./MobileTaskListView";

export const MobileTaskListWrapper: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  
  if (!token) {
    return <div>Kein Zugangstoken gefunden</div>;
  }
  
  return <MobileTaskListView token={token} />;
};